import React from 'react'
import { ListNav } from '.'
import { ContentOfficialAbout } from './content-official-about'
import { ContentOfficialContact } from './content-official-contact'
import { ContentOfficialMilestones } from './content-official-milestones'
import { ContentOfficialSocial } from './content-official-social'
import { ContentOfficialPartners } from './content-official-partners'
import { ContentOfficialTeam } from './content-official-team'
import { ContentOfficialFeatured } from './content-official-featured'

const ContentOfficial = ({activeTab, setActiveTab}) => {
  return (
    <div className="lg:pt-10 xl:pt-0">
      <div className="hidden xl:block ">
        <h1 className="text-4xl font-bold font-primary mb-12">
          Organization Profile
        </h1>
        <ListNav activeTab={activeTab} onChange={setActiveTab}/>
      </div>

      {
        activeTab === 'About' &&
        <ContentOfficialAbout />
      }
      {
        activeTab === 'Team Member' &&
        <ContentOfficialTeam />
      }
      {
        activeTab === 'Contact & Location' &&
        <ContentOfficialContact />
      }
      {
        activeTab === 'Milestones' &&
        <ContentOfficialMilestones />
      }
      {
        activeTab === 'Social Media' &&
        <ContentOfficialSocial />
      }
      {
        activeTab === 'Partners' &&
        <ContentOfficialPartners />
      }
      {
        activeTab === 'Featured Items' &&
        <ContentOfficialFeatured />
      }
    </div>
  )
}

export { ContentOfficial }
